import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { Container } from '../ui/Container';
export function AnnouncementBar() {
  return <div className="bg-gray-900 text-white py-2 text-sm font-medium" data-id="element-1">
      <Container className="flex flex-col sm:flex-row justify-between items-center gap-2 text-center sm:text-left" data-id="element-2">
        <p className="text-gray-300" data-id="element-3">
          Australia-wide printing & signage solutions
        </p>
        <div className="flex items-center gap-6" data-id="element-4">
          <a href="#quote" className="flex items-center text-cyan-400 hover:text-cyan-300 transition-colors group" data-id="element-5">
            Request a fast quote
            <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-6" />
          </a>
          <a href="tel:0894033306" className="flex items-center text-white hover:text-gray-200 transition-colors" data-id="element-7">
            <Phone className="mr-2 h-3 w-3 fill-current" data-id="element-8" />
            <span className="hidden sm:inline" data-id="element-9">08 9403 3306</span>
            <span className="sm:hidden" data-id="element-10">Call Us</span>
          </a>
        </div>
      </Container>
    </div>;
}